import { BaseDivider } from "@/shared/ui/base-divider";
import { Dialog, Stack, Typography, useTheme } from "@mui/material";
import type React from "react";
import type { AccountRequestCreatePageProps } from "../model";
import { AccountRequestForm } from "./AccountRequestForm";

export const AccountRequestCreatePage: React.FC<
  AccountRequestCreatePageProps
> = (props) => {
  const theme = useTheme();
  return (
    <>
      <Dialog fullWidth maxWidth="xl" open={props.requestStatus === "success"}>
        <Stack
          sx={{
            width: "100%",
            height: "100%",
            overflow: "scroll",
            backgroundColor: theme.palette.grey[50],
          }}
          alignItems="center"
          justifyContent="start"
          p={12}
          spacing={4}
        >
          <Typography variant="h4">登録申請を受け付けました</Typography>
          <Typography variant="body1" textAlign="center">
            ご登録いただいた内容を確認の上、担当者よりご連絡いたします。
            <br />
            申請内容を変更されたい場合、弊社までご連絡ください。
          </Typography>
          <Typography variant="body2">
            メールアドレス : support@xmile.co.jp
          </Typography>
        </Stack>
      </Dialog>

      <Stack
        sx={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          backgroundColor: theme.palette.grey[50],
        }}
        alignItems="center"
        justifyContent="start"
      >
        <Stack spacing={2} p={8} alignItems="center">
          <Stack
            p={4}
            spacing={4}
            sx={{
              border: "1px solid",
              borderColor: theme.palette.grey[300],
              backgroundColor: "white",
            }}
            alignItems="stretch"
          >
            <Stack p={0} spacing={1} alignItems="center">
              <Stack direction="row" alignItems="start" spacing={1}>
                <img
                  src="/logipoke-connect-logo.svg"
                  height="24px"
                  aria-label="Logo"
                  alt="logo"
                />
              </Stack>
              <Typography variant="h5" sx={{ textAlign: "center" }}>
                会社登録申請
              </Typography>
            </Stack>
            <BaseDivider />
            <Stack p={0} spacing={4} alignItems="stretch">
              <Stack spacing={2}>
                <Typography variant="body1">
                  会社情報を入力してください。登録申請後、担当者よりご連絡いたします。
                </Typography>
                <AccountRequestForm
                  requestStatus={props.requestStatus}
                  errorMessage={props.errorMessage}
                  onSubmit={props.onAccountRequestSubmit}
                />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
